import { useEffect } from "react";
import { BrowserRouter, useLocation } from 'react-router-dom'
import { AppRoutes } from './router'
import { initGA, trackPageView } from "./services/analytics";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AnalyticsTracker />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App